import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PersonInfo from '../../../../../components/personInfo';
import Desc from '../../../../../components/desc';
import MainInfo from '../../../../../components/mainInfo';

class CommentList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        pageInfo: PropTypes.object,
    };

    render() {
        const { content, pageInfo } = this.props;

        return (
            <div className={styles.home_list}>
                {content.length > 0
                    ? content.map((item, index) => {
                          const personalInfoData = {
                              //   lev: pageInfo.lev,
                              userimg: pageInfo.userimg,
                              nickname: pageInfo.nickname,
                              add_time: item.add_time,
                              ip_from: item.ip_from,
                              share_url: item.share_url,
                              isOnClickDocTitle: true,
                          };

                          //   const descData = {
                          //       like_num: item.like_num,
                          //       comment_num: item.comment_num,
                          //   };

                          const mainInfoData = {
                              ...item,
                              sub_name: item.sub_name,
                              comment_contents: item.comment_contents,
                              share_url: item.share_url,
                          };

                          return (
                              <div key={index}>
                                  <div className={styles.doc_item}>
                                      <PersonInfo content={personalInfoData} fromPage="personal" />
                                  </div>
                                  <MainInfo content={mainInfoData} pageInfo={pageInfo} />
                                  {/* <Desc content={descData} pageInfo={pageInfo} /> */}
                              </div>
                          );
                      })
                    : ''}
            </div>
        );
    }
}

export default errorBoundary(CommentList);
